import src from "IMAGE";
export default { src, width: 2880, height: 800, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAJElEQVR42m3KsQkAAAgDwey/sLEQRWwkpDj44sGsVsGzDTd8AxgYPs2rF5s2AAAAAElFTkSuQmCC"};
